<template>
  <div class='border-t bg-white flex flex-col pt-6 h-48'>
    <div class='layout-container w-full bg-white flex flex-row justify-between px-4 lg:px-0'>
      <div class='grid grid-cols-2 gap-x-4 gap-y-2 lg:gap-x-12 lg:gap-y-4'>
      </div>
      <div>
        <img :src='eventConfigLogoImageUrl'
         class='h-4 lg:h-10 cursor-pointer mb-6'
         @click='goToHome'/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Gbcc2025LayoutFooter',
  computed: {
    ...mapGetters('events', [
      'eventConfigLogoImageUrl',
      'eventMainThemeColor'
    ]), 
    footerNavStyle () {
      return {
        '--color': this.eventMainThemeColor
      }
    }
  },
  methods: {
    goToHome () {
      this.$router.push({name: 'Home'}).catch(() => {})
    },
  }
}
</script>

<style lang='scss' scoped>
.footer-nav-link {
  @apply uppercase text-gray-700 text-xs block opacity-75;
}

.footer-nav-link.router-link-active {
  color: var(--color);
  @apply font-bold;
}

.footer-nav-link:hover {
  @apply opacity-100;
  color: var(--color);
}
</style>
